import React, { useEffect, useContext, useState, useRef } from 'react'
import moment from 'moment'
import 'moment/locale/fr'
import {
  Hidden,
  Box,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  CircularProgress,
} from '@mui/material'
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';


import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
// S4 : icones Figma (upload nuage, document, croix de suppression)
import uploadCloudIcon from '../../images/uploadCloudIcon.svg';
import documentIcon from '../../images/documentIcon.svg';
import deleteFileIcon from '../../images/deleteFileIcon.svg';
import CloseIcon from '@mui/icons-material/Close';
import {
  UploadCloud as UploadCloudIcon,
} from 'react-feather';

import ScansContext from "../../contexts/ScansContext"

import { readString } from "react-papaparse"
import APIS from "../../utils/APIS"
import { OPTIONS_LECTURE_CSV, vraiesErreurs } from "../../utils/lectureCsv"
import { estLimiteInvitations, messageLimiteInvitations } from "../../utils/limiteInvitations"

moment.locale("fr");


const AddMultipleCandidats = ({actScan, onClose}) => {

  const theme = useTheme();
  const mediaQueryUpSm = useMediaQuery(theme.breakpoints.up('sm'));

  const { getScans } = useContext(ScansContext)

  const [step, setStep] = useState(0)
  const handleChange = (event) => {
    setFileStatus({
      ...fileStatus,
      selectColumn: event.target.value,
    })
  }

  const [candidatsFile, setCandidatsFile] = useState(null)
  const [fileStatus, setFileStatus] = useState({})
  const uploadInputRef = useRef(null)

  // Point 4 : jamais d'action sans retour visuel. Chaque cause d'echec a son
  // message, l'analyse du fichier a son etat de chargement, et l'erreur
  // s'affiche des l'ecran de depot (elle n'attendait avant que l'etape 1).
  const messagesErreur = {
    lecture : "Le fichier n'a pas pu être lu. Vérifiez qu'il s'agit bien d'un fichier .csv.",
    vide : "Le fichier est vide.",
    tropDeLignes : "Le fichier dépasse 100 lignes. Divisez votre liste et recommencez.",
    aucuneColonne : "Aucune colonne remplie n'a été trouvée. Vérifiez que la première ligne est un en-tête et que la colonne des adresses email est remplie.",
  }

  const onChangeUploadInput = (e) => {
    let fichier = e?.target?.files[0]
    if (!fichier) { return }
    setCandidatsFile(fichier)
    setFileStatus({status:"analyse"})

    var reader = new FileReader();
    reader.onerror = function() {
      setFileStatus({status:"error", raison:messagesErreur.lecture})
    }
    reader.onload = function(e) {
      if (reader.result) {
        readString(reader?.result, {
          ...OPTIONS_LECTURE_CSV, // B53 : virgule, point-virgule ou tabulation
          complete: (results) => {
            if (vraiesErreurs(results.errors).length > 0) {
              setFileStatus({status:"error", raison:messagesErreur.lecture})
            } else if (results.data && results.data.length > 0 & results?.meta?.fields?.length > 0) { //OK
              let datas = results.data
              let headers = results?.meta?.fields
              if (datas?.length > 100) {
                setFileStatus({status:"error", raison:messagesErreur.tropDeLignes})
              } else if (datas?.length >= 1) {
                //on regarde chaque colonne voir si c'est vide
                let finalHeaders = []
                headers.forEach((header) => {
                  let thisCount = 0
                  datas?.forEach((data) => {
                    if (data[header]) {
                      thisCount++
                    }
                  })
                  finalHeaders.push({
                    header : header,
                    count : thisCount
                  })
                })
                finalHeaders = finalHeaders.filter((el) => el.count > 0)
                finalHeaders = finalHeaders.map((el) => el.header)
                if (finalHeaders?.length > 0) {
                  setFileStatus({
                    status : "ok",
                    finalHeaders : finalHeaders,
                    datas : datas,
                    /* La colonne des adresses d'office : un fichier Excel met
                       souvent « Nom » en premier, et envoyer cette colonne-la
                       donnait « emails inutilisables » (relecture du 25/09). */
                    selectColumn : finalHeaders.find((h) => /mail/i.test(h))
                      || finalHeaders.find((h) => datas.some((d) => String(d[h] || "").includes("@")))
                      || finalHeaders[0],
                  })
                } else {
                  setFileStatus({status:"error", raison:messagesErreur.aucuneColonne})
                }
              } else {
                setFileStatus({status:"error", raison:messagesErreur.vide})
              }
            } else {
              setFileStatus({status:"error", raison:messagesErreur.vide})
            }
          },
        })
      } else {
        setFileStatus({status:"error", raison:messagesErreur.vide})
      }
    }
    try {
      reader.readAsText(fichier);
    } catch (e) {
      console.log(e)
      setFileStatus({status:"error", raison:messagesErreur.lecture})
    }
  }

  // Point 8 : un fichier modele telechargeable — une colonne « email »,
  // deux lignes d'exemple.
  const telechargerModele = () => {
    const contenu = "email\nprenom.nom@exemple.fr\ncandidate@exemple.fr\n"
    const lien = document.createElement('a')
    lien.setAttribute('href', 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(contenu))
    lien.setAttribute('download', 'modele-liste-candidats.csv')
    lien.style.visibility = 'hidden'
    document.body.appendChild(lien)
    lien.click()
    document.body.removeChild(lien)
  }


  return (
    <>
      <Hidden smUp>
        <Box sx={{
          paddingLeft:"5px",
          paddingRight:"5px",
          paddingTop:"10px",
          display:"flex",
          overflow:"hidden",
          maxWidth:"100%",
          gap:"5px",
        }}>
          <Button
            variant="text"
            size={"medium"}
            onClick={() => { }}
            sx={{
              padding:"0px 4px",
              minWidth:0,
              visibility:"hidden",
            }}
          >
            <ChevronLeftIcon/>
          </Button>
          <Box sx={{
            flexGrow:1,
            fontSize:"16px",
            color:"text.primary",
            fontWeight:400,
            textAlign:"center",
            textOverflow:"ellipsis",
            overflow:"hidden",
            whiteSpace:"nowrap",
            useSelect:"none",
            textTransform:"capitalize",
          }}>
            {actScan?.name}
          </Box>
          <Button
            variant="text"
            size={"medium"}
            onClick={onClose}
            sx={{
              padding:"0px 4px",
              minWidth:0,
            }}
          >
            <CloseIcon/>
          </Button>
        </Box>
      </Hidden>
      {/* Q3 : la croix de fermeture existait sur mobile mais pas sur desktop */}
      <Hidden smDown>
        <Box sx={{
          position:"absolute",
          top:"15px",
          right:"15px",
        }}>
          <CloseIcon
            onClick={onClose}
            sx={{
              cursor:"pointer",
              color:"text.black",
              width:"28px",
              height:"28px",
            }}
          />
        </Box>
      </Hidden>
      <Box sx={{
        display:"flex",
        flexDirection:"column",
        height:"100%",
        padding:["25px", "30px", "40px"],
        gap:"20px",
      }}>
        <Box sx={{
          textAlign:"center",
          color:"text.black",
          fontWeight:500,
          fontSize:["22px", "36px", "36px"],
        }}>
          Liste de candidats
        </Box>
        <input ref={uploadInputRef} name="fileCandidats" type="file" accept="text/csv" style={{display:"none"}} onChange={onChangeUploadInput}/>

        {(step === 2  || step === 3) &&
          <>
            <Box sx={{
              textAlign:"center",
              color:"text.primary",
              fontWeight:400,
              fontSize:["15px", "18px", "18px"],
            }}>
              Vérification et envoi des invitations ...
            </Box>
            <Box sx={{flexGrow:1, display:"flex", justifyContent:"center"}}>
              {step === 2 &&
                <CircularProgress size="60px" sx={{
                  marginTop:"8px",
                  marginBottom:"8px",
                }}/>
              }
              {step === 3 &&
                <>
                  {fileStatus?.finalError ? (
                    <Box sx={{
                      fontSize:"22px",
                      fontWeight : 500,
                      color:"red",
                      textAlign:"center",
                    }}>
                      {fileStatus?.finalError === "limiteInvitations" ? messageLimiteInvitations(fileStatus?.refusServeur) : "Une erreur est survenue, merci de vérifier vos données."}
                    </Box>
                  ) : (
                    <Box sx={{
                      marginTop:"8px",
                      marginBottom:"8px",
                    }}>
                      {(fileStatus?.finalResult?.complete?.length === 0 && fileStatus?.finalResult?.errors?.length > 0) &&
                        <Box sx={{
                          fontSize:"20px",
                          fontWeight : 500,
                          color:"text.black",
                          textAlign:"center",
                        }}>
                          Malheureusement votre liste ne comporte que des emails inutilisables, merci de vérifier vos données.
                        </Box>
                      }
                      {(fileStatus?.finalResult?.complete?.length > 0 && fileStatus?.finalResult?.errors?.length === 0) &&
                        <Box sx={{
                          fontSize:"20px",
                          fontWeight : 500,
                          color:"text.black",
                          textAlign:"center",
                        }}>
                          Nous avons invité {fileStatus?.finalResult?.complete?.length} candidats&nbsp;!
                        </Box>
                      }
                      {(fileStatus?.finalResult?.complete?.length > 0 && fileStatus?.finalResult?.errors?.length > 0) &&
                        <Box sx={{
                          fontSize:"20px",
                          fontWeight : 500,
                          color:"text.black",
                          textAlign:"center",
                        }}>
                          Nous avons invité {fileStatus?.finalResult?.complete?.length} candidats&nbsp;!
                          <br/><br/>
                          Malheureusement, {fileStatus?.finalResult?.errors?.length} emails sont en échec, merci de vérifier vos données.
                        </Box>
                      }
                    </Box>
                  )}
                </>
              }
            </Box>
            <Box sx={{display:"flex", flexDirection:"column", gap:"5px", alignItems:"center"}}>
              <Button
                color="primary"
                size="large"
                fullWidth
                sx={{
                  maxWidth:"420px",
                }}
                variant="contained"
                onClick={onClose}
                disabled={step === 3 ? false : true}
              >
                Fermer
              </Button>
            </Box>
          </>
        }

        {step === 1 &&
          <>
            <Box sx={{
              textAlign:"center",
              color:"text.primary",
              fontWeight:400,
              fontSize:["15px", "18px", "18px"],
            }}>
              Sélectionner la colonne contenant les emails.
            </Box>
            <Box sx={{flexGrow:1, display:"flex", justifyContent:"center"}}>
              {fileStatus?.status === "ok" ? (
                  <FormControl
                    fullWidth
                    sx={{
                      marginTop:"16px",
                      marginBottom:"8px",
                      maxWidth:"420px",
                      "& .MuiInputBase-root": {
                        background:mediaQueryUpSm ? "#FAF8F6" : "white",
                      },
                      "& .MuiInputBase-input" : {
                        flexDirection:"column",
                        display:"flex",
                      },
                    }}
                  >
                    <InputLabel id="selectEmailColumn-label">Adresse email</InputLabel>
                    <Select
                      label="Adresse email"
                      labelId="selectEmailColumn-label"
                      id="selectEmailColumn"
                      value={fileStatus?.selectColumn}
                      onChange={handleChange}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxWidth:"420px",
                            '& .MuiMenuItem-root': {
                              flexDirection: "column",
                              alignItems:"flex-start",
                            },
                          },
                        },
                      }}
                    >
                      {fileStatus?.finalHeaders?.map((header, index) => {
                        let lists = []
                        fileStatus?.datas?.forEach((data) => {
                          let val = data[header]
                          if (val) {
                            lists.push(data[header])
                          }
                        })
                        let stringList = lists.join(', ')
                        return (
                          <MenuItem key={index} value={header}>
                            <span style={{fontWeight:400, fontSize:"16px", color:"black", textTransform:"capitalize"}}>
                              {header}
                            </span>
                            <span style={{fontWeight:400, fontSize:"13px", color:"#565656", overflow:"hidden", whiteSpace:"nowrap", textOverflow:"ellipsis", maxWidth:"100%"}}>
                              {stringList}
                            </span>
                          </MenuItem>
                        )
                      })}
                    </Select>
                  </FormControl>
              ) : (
                <Box sx={{
                  fontSize:"22px",
                  fontWeight : 500,
                  color:"red",
                  textAlign:"center",
                }}>
                  Une erreur est survenue, merci de vérifier vos données.
                </Box>
              )}
            </Box>
            <Box sx={{display:"flex", flexDirection:"column", gap:"5px", alignItems:"center"}}>
              <Button
                color="primary"
                size="large"
                fullWidth
                sx={{
                  maxWidth:"420px",
                }}
                variant="contained"
                endIcon={<ChevronRightIcon/>}
                onClick={() => {
                  setStep(2)
                  //on envoie au back pour vérifier les données, inviter et nous retourner les infos et erreurs
                  let emails = []
                  fileStatus?.datas?.forEach((data) => {
                    if (data[fileStatus?.selectColumn]) {
                      emails.push(data[fileStatus?.selectColumn]?.trim())
                    }
                  })
                  let uniqueEmails = [...new Set(emails)]
                  if (uniqueEmails?.length > 0) {
                    let closeDate = moment(actScan?.plan?.plan[0]?.closeDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
                    APIS.addMultipleCandidats({emails : uniqueEmails, groupeID : actScan?.id, closeDate : closeDate}).then((result) => {
                      if (result && result?.message === "addMultipleCandidats") {
                        setFileStatus({
                          ...fileStatus,
                          finalResult : {
                            complete : result?.complete,
                            errors : result?.errors,
                          }
                        })
                        setStep(3)
                        getScans()
                      } else if (estLimiteInvitations(result)) {
                        setFileStatus({
                          ...fileStatus,
                          finalError : "limiteInvitations",
                          refusServeur : result,
                        })
                        setStep(3)
                      } else { //error
                        setFileStatus({
                          ...fileStatus,
                          finalError : "error"
                        })
                        setStep(3)
                      }
                    });
                  } else {
                    setFileStatus({
                      ...fileStatus,
                      finalError : "noEmails"
                    })
                    setStep(3)
                  }
                }}
                disabled={(fileStatus?.status === "ok" && fileStatus?.selectColumn) ? false : true}
              >
                Envoyer les invitations
              </Button>
              <Button
                variant="text"
                size={"medium"}
                fullWidth
                onClick={() => {
                  setStep(0)
                }}
                sx={{
                  fontSize:"16px",
                  fontWeight:500,
                  maxWidth:"420px",
                }}
              >
                Retour
              </Button>
            </Box>
          </>
        }

        {step === 0 &&
          <>
            {/* Point 8 : consigne reecrite (l'ancienne se lisait « inviter
                sur une colonne » et ecrivait « entête » sans trait d'union) */}
            <Box sx={{
              textAlign:"center",
              color:"text.primary",
              fontWeight:400,
              fontSize:["15px", "18px", "18px"],
            }}>
              Sélectionnez un fichier .csv contenant, dans une seule colonne, les adresses email des candidats à inviter. La première ligne doit être un <b>en-tête</b>. 100 lignes maximum.
            </Box>
            {/* S4 : meme design que l'upload du job posting (Figma Create Scan).
                Etat vide = zone pointillee 6-6 fond #FAF8F6, nuage 32x25 #565656.
                Etat rempli = ligne fichier 60px, bordure pleine, doc + croix noire. */}
            <Box sx={{flexGrow:1, display:"flex", justifyContent:"center", alignItems:"center"}}>
              {candidatsFile === null ? (
                <Box
                  sx={{
                    marginTop:"8px",
                    marginBottom:"8px",
                    height:"185px",
                    width:"100%",
                    maxWidth:"590px",
                    background:"#FAF8F6",
                    backgroundImage:`url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23E7E7E7' stroke-width='2' stroke-dasharray='6%2c6'/%3e%3c/svg%3e")`,
                    cursor:"pointer",
                    display:"flex",
                    flexDirection:"column",
                    justifyContent:"center",
                    alignItems:"center",
                    userSelect:"none",
                    gap:"18px",
                    "&:hover":{
                      backgroundImage:`url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='black' stroke-width='2' stroke-dasharray='6%2c6'/%3e%3c/svg%3e")`,
                    }
                  }}
                  onClick={() => uploadInputRef.current && uploadInputRef.current.click()}
                >
                  <img src={uploadCloudIcon} style={{width:"32px", height:"25px"}} alt=""/>
                  <Box sx={{
                    fontSize:"16px",
                    color:"#565656",
                  }}>
                    Télécharger une liste
                  </Box>
                  {/* Point 4 : le format accepte est annonce avant que le
                      selecteur ne grise les autres fichiers */}
                  <Box sx={{
                    fontSize:"14px",
                    color:"#565656",
                  }}>
                    Format accepté&nbsp;: .csv (100 lignes maximum)
                  </Box>
                </Box>
              ) : (
                <Box sx={{
                  marginTop:"8px",
                  marginBottom:"8px",
                  height:"60px",
                  width:"100%",
                  maxWidth:"590px",
                  background:"#FAF8F6",
                  border:"1px solid #E7E7E7",
                  display:"flex",
                  alignItems:"center",
                  paddingLeft:"20px",
                  paddingRight:"20px",
                  gap:"15px",
                  userSelect:"none",
                }}>
                  <img src={documentIcon} style={{width:"18px", height:"20px"}} alt=""/>
                  <Box sx={{
                    fontSize:"16px",
                    color:"text.black",
                    flex:1,
                    overflow:"hidden",
                    textOverflow:"ellipsis",
                    whiteSpace:"nowrap",
                  }}>
                    {candidatsFile?.name}
                  </Box>
                  <img
                    src={deleteFileIcon}
                    style={{width:"25px", height:"25px", cursor:"pointer"}}
                    alt="Supprimer"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setCandidatsFile(null)
                      setFileStatus({})
                      if (uploadInputRef.current) {
                        uploadInputRef.current.value = null
                      }
                    }}
                  />
                </Box>
              )}
            </Box>
            {/* Point 4 : retour visuel systematique — analyse en cours ou
                erreur avec sa raison, directement sous la zone de depot */}
            {fileStatus?.status === "analyse" &&
              <Box sx={{display:"flex", justifyContent:"center", alignItems:"center", gap:"10px", color:"text.primary", fontSize:"15px"}}>
                <CircularProgress size="18px"/> Analyse du fichier…
              </Box>
            }
            {fileStatus?.status === "error" &&
              <Box sx={{
                textAlign:"center",
                color:"red",
                fontSize:"15px",
                fontWeight:500,
              }}>
                {fileStatus?.raison}
              </Box>
            }
            {/* Point 8 : fichier modele */}
            <Box sx={{textAlign:"center", fontSize:"15px"}}>
              <Box
                component="span"
                onClick={telechargerModele}
                sx={{
                  color:"text.black",
                  textDecoration:"underline",
                  cursor:"pointer",
                  userSelect:"none",
                }}
              >
                Télécharger un modèle .csv
              </Box>
            </Box>
            <Box sx={{display:"flex", flexDirection:"column", gap:"5px", alignItems:"center"}}>
              <Button
                color="primary"
                size="large"
                fullWidth
                sx={{
                  maxWidth:"420px",
                }}
                variant="contained"
                endIcon={<ChevronRightIcon/>}
                onClick={() => {
                  setStep(1)
                }}
                disabled={fileStatus?.status !== "ok"}
              >
                Continuer
              </Button>
            </Box>
          </>
        }
      </Box>
    </>
  )
}


export default AddMultipleCandidats
